<div>
  <h1>Welcome to Weld Manager Tool</h1>
  <br />
  <h4>Please select an option to start navigating.</h4>
</div>
